<section>
  <h3 class="mat-headline">About {{companyInformation.name}}'s distribution system</h3>
  <p class="mat-subheading-1">{{companyInformation.name}} is an open platform on which anyone can write.
    As a writer on {{companyInformation.name}}, you will always completely own your content, and it will be hosted for free indefinitely.
    This applies whether you choose to make your content freely accessible to all readers.
  </p>

  <br />

  <p class="mat-subheading-1">When you publish on {{companyInformation.name}}, your story is immediately accessible and available to share with readers.
  There is no review, no approval, and no waiting.
  </p>

  <br />

  <p class="mat-subheading-1">{{companyInformation.name}} also recommends stories to readers across various surfaces — like the homepage, category pages, and emails — based on their interests.
    {{companyInformation.name}} uses human curators and is working on an algorithmic distribution method to share great stories with readers.
    All stories published on {{companyInformation.name}} are eligible for further distribution.
  </p>
</section>
